export function renderLifecycleHookImportContentTemplate(): string {
  return `\nimport { getAuditRequestMetadata } from '@admin/actions/audit/get-audit-request-metadata'
import { runAfterHooks, runBeforeHooks } from '@admin/lib/lifecycle-hooks'`
}
